var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroundFloor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 16.5V10.9597C3 9.5927 3.6214 8.2998 4.68886 7.44583L8.8765 4.09568C10.7026 2.63477 13.2974 2.63477 15.1235 4.09568L19.3111 7.44581C20.3786 8.29978 21 9.59268 21 10.9597V16.5C21 18.9853 18.9853 21 16.5 21H7.5C5.01472 21 3 18.9853 3 16.5Z",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11H5.83333C6.10947 11 6.33333 11.2239 6.33333 11.5V14.3333H9.16667C9.44281 14.3333 9.66667 14.5572 9.66667 14.8333V17.6667H12.5C12.7761 17.6667 13 17.8905 13 18.1667V21",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroundFloor);
export default __webpack_public_path__ + "static/media/groundFloor.a97b935883cc5a7b9f0e3d63da5fcb8d.svg";
export { ForwardRef as ReactComponent };